/**
 * @author: Michal Mlčoch <xmlcoc12@stud.fit.vutbr.cz>
 */

import {useEffect, useState} from "react";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import Grid from '@mui/material/Grid';
import DateTimePicker from '@mui/lab/DateTimePicker';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import {getFrom} from "../../data/api";

function AuctionFilter(props) {
    const [categories, setCategories] = useState([]);
    const statusList = [
        { label: 'Neschválená', name: "UNCONFIRMED" },
        { label: 'Schválená', name: "CONFIRMED" },
        { label: 'Ukončená', name: "CLOSED" },
        { label: 'Zamítnutá', name: "REFUSED" },
    ]
    const typeList = [
        { label: 'Otevřená', name: "OPEN" },
        { label: 'Uzavřená', name: "CLOSED" },
    ]

    const typeOffer = [
        { label: 'Nabídka', name: "OFFER" },
        { label: 'Poptávka', name: "DEMAND" },
    ]

    const [filterDateFrom, setFilterDateFrom] = useState(null);
    const [filterDateTo, setFilterDateTo] = useState(null);
    const [filterTitle, setFilterTitle] = useState("");
    const [filterStatus, setFilterStatus] = useState("");
    const [filterCategory, setFilterCategory] = useState(null);
    const [filterType, setFilterType] = useState(null);
    const [filterOfferType, setFilterOfferType] = useState(null);


    const filterDateFromChanged = (value) => {
        setFilterDateFrom(value);
    };

    const filterDateToChanged = (value) => {
        setFilterDateTo(value);
    };

    const filterTitleChanged = (value) => {
        setFilterTitle(value.target.value);
    };

    const filterCategoryChanged = (value) => {
        setFilterCategory(value);
    };

    const filterStatusChanged = (value) => {
        setFilterStatus(value);
    };

    const filterTypeChanged = (value) => {
        setFilterType(value);
    };

    const filterOfferTypeChanged = (value) => {
        setFilterOfferType(value);
    };

    const GetFilter = () => {
        return {
            fromDate: filterDateFrom,
            toDate: filterDateTo,
            status: filterStatus != null ? filterStatus.name : null,
            categoryID: filterCategory != null ? filterCategory.id : null,
            findInTitle: filterTitle ? filterTitle : null,
            type: filterType != null ? filterType.name : null,
            offerType: filterOfferType != null ? filterOfferType.name : null,
        }
    }

    useEffect(()=>{
        getFrom('/categories').then((res)=>{
            setCategories(res.data);
        }).catch((e)=>{
        console.error(e);
        })
    },[])

    return (
        <Grid container spacing={{ xs: 4, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 16, xl: 20}} className="filter">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid item xs={4} sm={4} md={4} lg={4} lg={4} xl={4}>
                    <TextField 
                        label="Hledat v nadpisu" 
                        variant="outlined" 
                        className="filterItem"
                        onChange={filterTitleChanged}
                        />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} lg={4} xl={4}>
                    <Autocomplete
                        className="filterItem"
                        disablePortal
                        options={categories}
                        getOptionLabel={(option) => option.title}
                        onChange={(e,v) => filterCategoryChanged(v)}
                        renderInput={(params) => <TextField {...params} label="Kategorie"/>}
                    />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} lg={4} xl={4}>
                    <Autocomplete
                        className="filterItem"
                        disablePortal
                        options={statusList}
                        onChange={(e,v) => filterStatusChanged(v)}
                        renderInput={(params) => <TextField {...params}  label="Status"/>}
                    />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} lg={4} xl={4}>
                    <Autocomplete
                        className="filterItem"
                        disablePortal
                        options={typeList}
                        onChange={(e,v) => filterTypeChanged(v)}
                        renderInput={(params) => <TextField {...params}  label="Styl aukce"/>}
                    />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} lg={4} xl={4}>
                    <Autocomplete
                        className="filterItem"
                        disablePortal
                        options={typeOffer}
                        onChange={(e,v) => filterOfferTypeChanged(v)}
                        renderInput={(params) => <TextField {...params}  label="Typ aukce"/>}
                    />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} lg={4} xl={4}>
                    <DateTimePicker 
                        className="filterItem"
                        label="Konec aukce od"
                        value={filterDateFrom}
                        onChange={filterDateFromChanged}
                        renderInput={(params) => <TextField {...params} className="filterItem"/> }
                    />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} lg={4} xl={4}>
                    <DateTimePicker 
                        className="filterItem"
                        label="Konec aukce do"
                        value={filterDateTo}
                        onChange={filterDateToChanged}
                        renderInput={(params) => <TextField {...params} className="filterItem"/> }
                    />
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} lg={4} xl={4}>
                    <Button variant="contained" className="filterItem" onClick={() => props.applyFilter(GetFilter())}>Filtrovat</Button>
                </Grid>
        </LocalizationProvider>
        </Grid>
    )
}

export default AuctionFilter;